import React from 'react';
import { LoadingOutlined } from '@ant-design/icons';
import { Spin } from 'antd';

export const LoadingIndicator = ({ size, ...rest }) => (
  <Spin size={size} indicator={<LoadingOutlined {...rest} spin />} />
);
